import * as React from 'react'
import { observer } from 'mobx-react'
import {
  ModalSheet,
  ModalSheetHeader,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetContentDescription,
  ModalSheetFooter,
  ModalSheetFooterSpacer,
  ModalSheetFooterButtonGroup,
} from 'components/ModalSheet'
import Button from 'components/Button'
import OCRConfirmBulkRerunModalViewModel from './OCRConfirmBulkRerunModalViewModel'

/**
 * Confirm Bulk Rerun Modal
 */
export default observer(function OCRConfirmBulkRerunModal({
  vm,
}: {
  vm: OCRConfirmBulkRerunModalViewModel
}) {
  return (
    <ModalSheet
      showing={vm.showing}
      onRequestClose={vm.close}
      disableCloseOnOutsideClick
    >
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentIllustration
            src={require('assets/images/img_confirm-action.svg')}
          />
          <ModalSheetContentTitle>
            You are about to rerun{' '}
            {vm.ocrScopingJobBulkActionViewModel.bulkActionSelectedCount} jobs
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            Are you sure you want to proceed?
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button onClick={vm.close}>Close</Button>
          <Button type="primary" onClick={vm.confirm}>
            Rerun
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
